import { render, staticRenderFns } from "./ReviewsShortsPopupMobile.vue?vue&type=template&id=e9bdcd6a&scoped=true"
import script from "./ReviewsShortsPopupMobile.vue?vue&type=script&lang=js"
export * from "./ReviewsShortsPopupMobile.vue?vue&type=script&lang=js"
import style0 from "./ReviewsShortsPopupMobile.vue?vue&type=style&index=0&id=e9bdcd6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bdcd6a",
  null
  
)

export default component.exports